{
  "web3Wallet": "Exalt 交易所 Web3 钱包",
  "web3WalletSubtitle": "安全的 MetaMask / Trust Wallet · BNB智能链 · EXALT 钱包",
  "connectWallet": "连接钱包",
  "connectWeb3Wallet": "连接 Web3 钱包",
  "disconnect": "断开连接",
  "walletNotFound": "未找到钱包。",
  "walletAppNotFound": "未找到 MetaMask / Trust Wallet。",
  "installWallet": "请安装 MetaMask 或 Trust Wallet。",
  "walletConnected": "钱包连接成功。",
  "walletDisconnected": "钱包已断开连接。",
  "walletConnectionFailed": "钱包连接失败。",
  "walletAddress": "钱包地址",
  "walletAddressCopied": "钱包地址已复制。",
  "refreshBalance": "刷新余额",
  "totalAssets": "总资产",
  "assets": "资产",
  "send": "发送",
  "receive": "接收",
  "swap": "兑换",
  "history": "历史记录",
  "allWeb3Coins": "所有 Web3 币种",
  "searchCoin": "搜索币种...",
  "receiverAddress": "接收地址",
  "enterAmount": "输入数量",
  "sendNow": "立即发送",
  "receiveCrypto": "接收加密货币",
  "copyAddressReceive": "复制地址/接收",
  "swapTrade": "兑换/交易",
  "fromCoin": "从",
  "toCoin": "到",
  "swapNow": "立即兑换",
  "transactionHistory": "交易记录",
  "searchTransaction": "搜索交易...",
  "syncHistory": "同步历史记录",
  "syncReceive": "同步接收记录",
  "clearHistory": "清空历史记录",
  "clearHistoryConfirm": "确定要清空所有交易历史记录吗？",
  "noTransactionsYet": "暂无交易记录。",
  "bnbBalance": "BNB 余额",
  "insufficientBnbGas": "BNB 不足，请保留至少 0.01 BNB 用于支付Gas费。",
  "transactionPending": "交易处理中...",
  "transactionConfirmed": "交易已确认。",
  "bnbSentSuccessfully": "BNB 发送成功。",
  "bnbSendFailed": "BNB 发送失败。",
  "swapPending": "兑换处理中...",
  "swapCompleted": "兑换已完成。",
  "swapFailed": "兑换失败。",
  "approvalPending": "授权处理中...",
  "tokenSwapRouteSoon": "代币间兑换功能将通过 BNB 路由推出。",
  "receiveTransactionSynced": "接收交易已同步。",
  "noNewReceiveTransaction": "未发现新的接收交易。",
  "viewOnBscScan": "在 BscScan 上查看",
  "connectWalletFirst": "请先连接钱包。",
  "processing": "处理中...",
  "loading": "加载中...",
  "serverError": "服务器错误。",
  "sessionExpired": "会话已过期，请重新登录。"
}